export function findNeedleInHaystacks(needle: string, ...haystacks: (string | undefined)[]): string | undefined {
  needle = needle.toLowerCase().trim();
  for (let haystack of haystacks) {
    if (haystack == undefined) {
      continue;
    }
    haystack = haystack.toLowerCase();
    if (haystack.includes(needle)) {
      return haystack;
    }
  }
  return undefined;
}
